import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-login-load',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login-load.component.html',
  styleUrl: './login-load.component.scss'
})
export class LoginLoadComponent implements OnChanges {
  @Input() isHome: boolean = false;
  @Input() isLoading : boolean = true;
  isAnimate : boolean = false;
  ngOnChanges(changes: SimpleChanges): void {
    if(!this.isLoading){
      this.isAnimate = true;
    }
  }

}
